import React from 'react';
function SortDesc() {
    return (React.createElement("g", null,
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
        React.createElement("path", { d: "M13,16V4H11V16H8l4,4,4-4Z" })));
}
export default SortDesc;
